import styled from 'styled-components';
import Text from '../../../../../typography';

export const FormErrorSC = styled(Text)`
  color: ${({ theme }) => theme.color.tint.error} !important;
  padding: 0 8px;
`;
